import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { easeOutStrong } from "@/lib/motion";

export default function PricingCard({ pkg }) {
    const featured = !!pkg.is_featured;
    return (
        <motion.div
            data-testid={`pricing-card-${pkg.id || pkg.name}`}
            className={`relative rounded-2xl p-7 flex flex-col h-full ${
                featured
                    ? "bg-slate-950 text-white border-2 border-slate-950 shadow-xl"
                    : "bg-white border border-slate-200"
            }`}
            whileHover={{
                y: -8,
                scale: 1.02,
                boxShadow: featured
                    ? "0 30px 60px -15px rgba(124, 107, 255, 0.55)"
                    : "0 20px 40px -12px rgba(124, 107, 255, 0.35)",
            }}
            whileTap={{ scale: 0.99 }}
            transition={{ duration: 0.25, ease: easeOutStrong }}
            style={{ willChange: "transform" }}
        >
            {featured && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold tracking-[0.14em] uppercase bg-white text-slate-950 border border-slate-200">
                        Most Popular
                    </span>
                </div>
            )}
            <div>
                <h3
                    className={`font-display text-xl font-bold ${
                        featured ? "text-white" : "text-slate-950"
                    }`}
                >
                    {pkg.name}
                </h3>
                <p
                    className={`text-sm mt-2 leading-relaxed ${
                        featured ? "text-slate-300" : "text-slate-600"
                    }`}
                >
                    {pkg.short_description}
                </p>
            </div>
            <div className="mt-6">
                <div
                    className={`font-display text-4xl font-black ${
                        featured ? "text-white" : "text-slate-950"
                    }`}
                >
                    {pkg.price_display}
                </div>
                {pkg.best_for && (
                    <div
                        className={`text-xs mt-2 ${
                            featured ? "text-slate-400" : "text-slate-500"
                        }`}
                    >
                        {pkg.best_for}
                    </div>
                )}
            </div>
            <ul className="space-y-2.5 mt-6 flex-1">
                {(pkg.features || []).map((f, i) => (
                    <li
                        key={i}
                        className={`flex items-start gap-2.5 text-sm ${
                            featured ? "text-slate-200" : "text-slate-700"
                        }`}
                    >
                        <span
                            className={`w-5 h-5 rounded-full grid place-items-center shrink-0 mt-0.5 ${
                                featured
                                    ? "bg-white text-slate-950"
                                    : "bg-slate-950 text-white"
                            }`}
                        >
                            <Check className="w-3 h-3" strokeWidth={3} />
                        </span>
                        <span className="leading-snug">{f}</span>
                    </li>
                ))}
            </ul>
            <Button
                asChild
                size="lg"
                className={`mt-7 font-semibold ${
                    featured
                        ? "bg-white text-slate-950 hover:bg-slate-100"
                        : "bg-slate-950 hover:bg-slate-800 text-white"
                }`}
            >
                <Link to="/contact">
                    {pkg.cta_text || "Enquire now"}
                    <ArrowRight className="w-4 h-4 ml-1" />
                </Link>
            </Button>
        </motion.div>
    );
}
